import { render, staticRenderFns } from "./BaseVueMultiSelect.vue?vue&type=template&id=0a5f145c&scoped=true"
import script from "./BaseVueMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseVueMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseVueMultiSelect.vue?vue&type=style&index=0&id=0a5f145c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5f145c",
  null
  
)

export default component.exports